// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vckd","colBig":"styles_colBig__1Dhh9","colSmall":"styles_colSmall__1JAfG"};